module.exports = __webpack_public_path__ + "img/es_text_recolored.512644da.svg";